module.exports = __webpack_public_path__ + "static/img/032.170f943.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/datav-gejiachecun/032.png
// module id = HNkC
// module chunks = 1